export const formEl = [
  {
    label: "Text",
    value: "text",
  },
  {
    label: "TextArea",
    value: "textarea",
  },
  {
    label: "Number",
    value: "number",
  },
  {
    label: "Radio",
    value: "radio",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Time",
    value: "time",
  }
];
